import { Pipe, PipeTransform } from '@angular/core';
import { PromoType } from '@data/domain/promo.entity';
import { PromoObject } from '@usecase/content/get-content.interface';
import { DateTime } from './date-time.interface';

@Pipe({
    name: 'dateTime',
    standalone: true
})
// ambil formatter dari shared utils formatter
export class DateTimePipe implements PipeTransform {
    transform(data:PromoObject, promoType: PromoType): DateTime {
        const DATE = {
            start: data.start_date,
            end: data.end_date
          };

          const START_TIME_INDEX = 0;
          const START_TIME_LENGTH = 5;

          const TIME = {
            start: data.start_time.substring(START_TIME_INDEX, START_TIME_INDEX + START_TIME_LENGTH),
            end: data.end_time.substring(START_TIME_INDEX, START_TIME_INDEX + START_TIME_LENGTH)
          };

          return promoType === 'affiliate' ? TIME : DATE;
    }

}
